import React, { Component } from 'react'
import PropTypes from 'prop-types'

import OrdersDoneList from 'components/OrdersDoneList'
import OrdersPendingList from 'components/OrdersPendingList'

class RevenueCenterOrders extends Component {
  static propTypes = {
    ordersDone: PropTypes.array,
    ordersPending: PropTypes.array,
    currentRevenueCenterName: PropTypes.string,
    orderWindowNames: PropTypes.object,
  }

  render() {
    const { ordersDone, ordersPending, orderWindowNames, currentRevenueCenterName } = this.props
    return (
      <div className="orders-lists">
        <OrdersDoneList
          currentRevenueCenterName={currentRevenueCenterName}
          ordersDone={ordersDone}
          orderWindowNames={orderWindowNames}
        />
        <OrdersPendingList ordersPending={ordersPending} />
      </div>
    )
  }
}

export default RevenueCenterOrders
